var App = App || {};

App.CustomModals = (() => {
    'use strict';
    let modals = [];

    const init = async () => {
        const response = await getModals();
        if (!response.ok) throw new Error('Failed to get modals');

        document.addEventListener('click', event => {
            const link = event.target.closest('a');
            if (!link) return;

            const url = new URL(link.href, window.location.origin).pathname.toLowerCase();

            if (modals.includes(url)) {
                event.preventDefault();
                event.stopPropagation();
                triggerModal(url, link);
            }
        });

        const siteTourCookie = App.Cookies.getItem("BHFCU_SiteTour");
        const siteTourUrl = '/site-tour';
        if (!siteTourCookie && modals.includes(siteTourUrl)) {
            triggerModal(siteTourUrl);
        }
    };

    const getModals = async () => {
        try {
            const response = await fetch('/Api/Modals/GetModalUrls');
            if (!response.ok) throw new Error('Network response was not ok');

            const result = await response.json();
            modals = [...result];

            return { ok: true, modals };
        } catch (error) {
            console.error('Error loading modals:', error);
            return { ok: false, error };
        }
    };

    const triggerModal = async (url, origin) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Failed to load modal');

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const modalEl = doc.querySelector('.modal');
            if (!modalEl?.id) return false;

            document.body.insertAdjacentHTML('beforeend', modalEl.outerHTML);
            const modal = document.getElementById(modalEl.id);

            const bsModal = new bootstrap.Modal(modal);
            modal.addEventListener('hidden.bs.modal', () => {
                if (origin) origin.focus();
                modal.remove();
            });

            bsModal.show();
            return true;
        } catch (err) {
            console.error('Modal load failed:', err);
            return false;
        }
    };

    return { init };
})();